export function shouldPolyfill() {
	return !Intl.Segmenter;
}
